import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MonitorItem } from '../../models/monitor-item';
import { MonitorService } from '../../services/monitor.service';
import { DatetimePickerComponent } from '../../../shared/datetime-picker/datetime-picker.component';

export interface MonitorAbsenceDialogResult {
    toDate: Date;
    description: string;
}

@Component({
    templateUrl: './monitor-absence-dialog.component.html',
    styleUrls: ['./monitor-absence-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, DatetimePickerComponent]
})
export class MonitorAbsenceDialogComponent implements OnInit {
    @Input() items: MonitorItem[] = [];

    minDate: Date = new Date();

    form = this.fb.group({
        toDate: [null, Validators.required],
        description: [null, Validators.required],
    });

    constructor(
        private activeModal: NgbActiveModal,
        private fb: UntypedFormBuilder) {
    }

    ngOnInit(): void {
    }

    async ok(): Promise<void> {
        const formValue = this.form.value;
        const result: MonitorAbsenceDialogResult = {
            toDate: formValue.toDate,
            description: formValue.description
        };
        this.activeModal.close(result);
    }

    cancel(): void {
        this.activeModal.close();
    }

    updateSelectedToDate(e: any) {
        this.form.controls['toDate'].setValue(e);
        this.form.controls['toDate'].markAllAsTouched();
    }
}
